export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_TOKEN = "CART_TOKEN";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_UPDATE_QUANTITIES = "CART_UPDATE_QUANTITIES";
export const CART_ADD_ALL = "CART_ADD_all";
export const CART_DELETE_ALL = "CART_DELETE_ALL";
